import styles from './template.css';
import template from './template';
import {AoflElement, customElement} from '@aofl/element';
import {storeInstance} from '@aofl/store/dist/legacy';
import '../side-panel-sdo';
import {sdoNs} from '../../../constants-enumerate';

/**
 * @summary SidePanelOffcanvasButton
 * @extends {AoflElement}
 */
@customElement('side-panel-offcanvas-button')
class SidePanelOffcanvasButton extends AoflElement {
  /**
   * Creates an instance of SidePanelOffcanvasButton.
   */
  constructor() {
    super();

    this.storeInstance = storeInstance;
  }

  /**
   * @readonly
   */
  static is = 'side-panel-offcanvas-button';
  clickHandler = () => {
    const state = this.storeInstance.getState(); // eslint-disable-line no-invalid-this

    this.storeInstance.commit({ // eslint-disable-line no-invalid-this
      namespace: sdoNs.SIDE_PANELS,
      mutationId: 'setLeftOffCanvas',
      payload: !state[sdoNs.SIDE_PANELS].left.offCanvas
    });
  };

  connectedCallback() {
    super.connectedCallback();

    this.addEventListener('click', this.clickHandler);
  }

  /**
   *
   * @return {Object}
   */
  render() {
    return super.render(template, [styles]);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.removeEventListener('click', this.clickHandler);
  }
}

export default SidePanelOffcanvasButton;
